import { LitElement } from "lit-element";

export class StofwareElement extends LitElement {
	static get properties() {
		return {};
	}
}
